import styled from "styled-components";
import { DARK_GRAY, LIGHT_BLUE, LIGHT_GRAY, LOW_BLUE, LOW_GRAY, NEAR_WHITE } from "../../config";

export const Container = styled.div<{ readOnly?: boolean }>`
  position: relative;
  display: flex;
  height: 30px;
  align-items: center;
  margin-left: 5px;

  .switch > .hidden-toggle {
    display: none;
  }

  .switch > .slider {
    background-color: ${LOW_GRAY};
    cursor: ${({ readOnly }) => (readOnly ? "not-allowed" : "pointer")};
    border-radius: 20px;
    transition: all 300ms ease-in-out;
    width: 36px;
    height: 14px;
    position: relative;
  }

  .switch > .slider > .button {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: ${LIGHT_GRAY};
    top: -3px;
    left: -5px;
    transition: all 300ms ease-in-out;
    border-radius: 50%;
  }

  .switch > .slider > .button::after {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f023";
    color: ${DARK_GRAY};
    text-align: center;
    padding-left: 6px;
    font-size: 8px;
  }

  .switch > .slider:after {
    position: absolute;
    top: 55%;
    right: 7px;
    transform: translate(0, -50%);
    font-size: 8px;
    line-height: 14px;
    color: ${LIGHT_GRAY};
    font-weight: bold;
    transition: all 300ms ease-in-out;
    content: "Off";
  }

  .switch > .hidden-toggle:checked ~ .slider {
    background-color: ${LOW_BLUE};
  }

  .switch > .hidden-toggle:checked ~ .slider > .button {
    left: 20px;
    background-color: ${LIGHT_BLUE};
  }

  .switch > .hidden-toggle:checked ~ .slider > .button::after {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content: "\f3c1";
    color: ${DARK_GRAY};
    text-align: center;
    padding-left: 6px;
    font-size: 8px;
  }

  .switch > .hidden-toggle:checked ~ .slider:after {
    right: 20px;
    color: ${LIGHT_GRAY};
    content: "On";
  }
`;

export const Label = styled.div`
  font-size: 13px;
  color: ${NEAR_WHITE};
  margin-left: 8px;
`;
